import React, { useContext } from 'react';
import cx from 'classnames';

import { StoreContext } from 'store';
import { Text } from 'components/Text';
import { Badges } from './Badges';
import { PaymentButton } from './PaymentButton';

import {
  generateItemTitleAnsSubtitle,
  generateSubtitleColor,
  countRemainingTime,
} from './utils';

import './Item.scss';
import { Icon } from 'components/Icons';
import { shopApi } from 'api';

interface SpecialItemProps {
  item: shopApi.Item;
  onPaymentClick?: (event: React.MouseEvent) => void;
  onItemClick?: (item: shopApi.Item) => void;
}

export const SpecialItem: React.FC<SpecialItemProps> = ({
  item,
  onPaymentClick = () => undefined,
  onItemClick = () => undefined,
}) => {
  const { translation: t } = useContext(StoreContext);
  const { title, subtitle } = generateItemTitleAnsSubtitle(item.name, t);

  const remainingTime = countRemainingTime(item, t);

  return (
    <div className={cx('item', 'item-special')} onClick={() => onItemClick(item)}>
      <div className={cx('item__image', 'item__image-special')}>
        <img src={item.image_url} alt={item?.name} />
      </div>

      <div className={cx('item__details', 'item__details-special')}>
        <Text.HeaderS className={cx('item__item-name', 'item__item-name-special')}>
          {title}
        </Text.HeaderS>
        {subtitle && (
          <Text.CapsM
            className="item__item-subtitle"
            style={{
              color: generateSubtitleColor(item.name),
            }}
          >
            {subtitle}
          </Text.CapsM>
        )}
        <PaymentButton item={item} onPaymentClick={onPaymentClick} />
        <RemainingTime remainingTime={remainingTime} />
      </div>
      <Badges item={item} />
    </div>
  );
};

interface RemainingTimeProps {
  remainingTime: string | null;
}

export const RemainingTime: React.FC<RemainingTimeProps> = ({ remainingTime }) => {
  if (!remainingTime) {
    return null;
  }

  return (
    <div className="item__remaining-time">
      <Icon.Clock className="item__clock-icon" />
      <Text.ParagraphL>{remainingTime}</Text.ParagraphL>
    </div>
  );
};
